export default __webpack_public_path__ + "static/beauty-summer-reference-d7201c5796cef0e718eb7290cb95a5dc.jpg";